import { useState, useEffect } from "react";

const VersionNotifier = () => {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [latestVersion, setLatestVersion] = useState(null);

  useEffect(() => {
    const checkForUpdate = async () => {
      try {
        const response = await fetch("/version.json", { cache: "no-store" });
        const { version } = await response.json();
        const currentVersion = localStorage.getItem("app_version");

        if (currentVersion && currentVersion !== version) {
          setLatestVersion(version);
          setNewVersionAvailable(true);
        } else {
          localStorage.setItem("app_version", version);
        }
      } catch (error) {
        console.error("Failed to check version:", error);
      }
    };

    checkForUpdate();
    const interval = setInterval(checkForUpdate, 500000);

    return () => clearInterval(interval);
  }, []);

  const handleRefresh = () => {
    if (latestVersion) {
      localStorage.setItem("app_version", latestVersion);
      setNewVersionAvailable(false);
      window.location.reload();
    }
  };

  return (
    newVersionAvailable && (
      <div className="fixed bottom-5 right-5 bg-gray-900 text-white p-4 rounded-lg shadow-lg">
        <p className="mb-2">A new update is available!</p>
        <button className="bg-blue-500 px-4 py-2 rounded" onClick={handleRefresh}>
          Refresh Now
        </button>
      </div>
    )
  );
};

export default VersionNotifier;
